var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Autenticación con GICAR")]),(_vm.loading)?_c('p',[_vm._v("Verificando usuario...")]):(_vm.error)?_c('p',[_vm._v(_vm._s(_vm.error))]):_c('p',[_vm._v("¡Autenticación exitosa!")])])}
var staticRenderFns = []

export { render, staticRenderFns }